
export class ExportField {
    nascita: boolean = true;
    iscrizione: boolean = true;
    laurea: boolean = true;
    annolaurea: boolean = true;
    ateneolaurea: boolean = true;
    residenza: boolean = true;
    studio: boolean = true;
    occupazione: boolean = true;
    elenchi: boolean = true;
}

export function exportField() {
    return ExportField;
}